export default "__VITE_ASSET__BpC9aaRk__"